import { CalendarDay } from "../models/calendar/calendarDay";
import { makeApiCallWithAny } from "./tokenService";

export const getCalendarDays = (
    startDate: string,
    endDate: string,
    signal?: AbortSignal
): Promise<CalendarDay[]> => {
    return makeApiCallWithAny<CalendarDay[]>(
        `api/calendardays?startDate=${startDate}&endDate=${endDate}`,
        signal
    );
};
